import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Switch, Route } from 'react-router-dom'
import Home from './homeViews/Home'
import Categories from './homeViews/Categories'
import Search from './homeViews/Search'
import StoreFinder from './map/StoreFinder'
import Store from './stores/Store'
import Item from './stores/Item'
import Account from './info/Account'
import Settings from './info/Settings'
import Help from './info/help/Help'
import Cart from './cart/Cart'
import Favorites from './cart/Favorites'
import Notify from './cart/Notify'
import Checkout from './cart/Checkout'
import Payment from './cart/Payment'
import History from './cart/History'
import Registration from './cart/Registration'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return this.props.children;
  }
}

const Scroll = withRouter(ScrollToTop);

const Main = (props) => (
  <main>
    <Scroll>
      <Switch>
        <Route exact path='/' component={Home}/>
        <Route exact path='/categories' component={Categories}/>
        <Route path='/search' component={Search}/>
        <Route exact path='/storefinder' component={StoreFinder}/>
        <Route path='/store/' component={Store}/>
        <Route path='/item' component={Item}/>
	      <Route exact path='/info/account' component={Account}/>
	      <Route exact path='/info/settings' component={Settings}/>
        <Route exact path='/info/help' component={Help}/>
        <Route exact path='/cart/cart' component={Cart}/>
        <Route exact path='/cart/favorites' component={Favorites}/>
        <Route exact path='/cart/notify' component={Notify}/>
     	  <Route exact path='/cart/checkout' component={Checkout}/>
        <Route exact path='/cart/payment' component={Payment}/>
	      <Route exact path='/cart/history' component={History}/>
        <Route exact path='/cart/registration' component={Registration}/>
      </Switch>
    </Scroll>
  </main>
)

export default Main
